import { render, staticRenderFns } from "./dataFilter.vue?vue&type=template&id=b4b16f22&"
import script from "./dataFilter.vue?vue&type=script&lang=js&"
export * from "./dataFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports